<template>
    <Maps :center="center" style="width: 100%; height: 100%;" :zoom="12">

        <!-- main location marker -->
        <MapAdvMarker v-if="mainLocation" :position="mainLocation.location" :pinElementOptions="mainLocation.pinElementOptions" 
        :title="mainLocation.title" :icon="mainLocation.icon">
        </MapAdvMarker>

        <!-- markers -->
        <MapAdvMarker :position="marker.location" v-for="marker in markers" :key="marker.id" 
            :pinElementOptions="marker.pinElementOptions" :title="marker.title"
            @mouseenter="m => mouseover(m,marker)" @mouseleave="m => mouseleave(m,marker)" @click="m => click(m,marker)">
        </MapAdvMarker>

        <!-- if show route -->
        <template v-if="plan != null">
            <MapRoute v-for="(route) in plan.routes" :key="route.encodedPolyline" :path="route">
            </MapRoute>
            
            <MapAdvMarker :position="plan.origin" :pinElementOptions="{glyphColor: '#FFFFFF'}" icon="mdi mdi-flag-checkered">
            </MapAdvMarker>

            <MapAdvMarker v-for="(route,index) in plan.routes" :key="'_' + route.encodedPolyline" :position="route.endLocation" 
                :pinElementOptions="{glyphColor: '#FFFFFF'}" :icon="`mdi mdi-numeric-${index+1}`">
            </MapAdvMarker>
        </template>
        
    </Maps>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';

export default {
    name: "PlannerMaps",
    props: {
        center: {
            type: Object,
            default: () => { return { lng: 10.7522, lat: 59.9139} }
        },
        mainLocationCoordinates: Object,
        routeData: Object
    },
    
    data() {
        return {
            markers: [],
            mainLocation: null,
            plan: null,
            jobIds: [],
        }
    },

    mounted() {
        this.getMainLocation();
        this.getRouteData();
        this.getJobLocations();
    },

    methods: {
        getMainLocation() {
            if (this.mainLocationCoordinates) {
                this.mainLocation = {
                    id: 0,
                    location: this.center,
                    title: "Main office",
                    pinElementOptions: {
                        background: 'black',
                        borderColor: 'white',
                        glyphColor: 'white',
                        scale: 1.5
                    },
                    icon: "mdi mdi-home",
                    label: "H"
                }       
            }
        },

        schedulerChange() {
            this.getRouteData()
        },

        mouseover(arg, item) {
            const jobIds = item.jobs.map(e=>e.Id);
            this.getJobListSelection.forEach(j => {
                j.hover = jobIds.includes(j.Id)
            })
        },

        mouseleave() {
            this.getJobListSelection.forEach(j => {
                j.hover = false
            })
        },

        click(m, item) {
            const jobIds = item.jobs.map(e=>e.Id);
            this.getJobListSelection.forEach(j => {
                j.selected = jobIds.includes(j.Id)
            })
        },

        getRouteData() {
            this.plan = null;
            if (this.routeData && this.routeData.userId) {
                ClientAPIMixin.methods.getRouteData(this.routeData.userId, this.routeData.date).then(response => {
                    this.plan = response
                })
            }
            else {
                this.plan = null
            }
        },

        getJobLocations() { 
            const jobIds = this.getJobListSelection.map(r => r.Id);
            const jobsAreEqual = jobIds.length === this.jobIds.length && jobIds.every((value, index) => value === this.jobIds[index]);
            if (!jobsAreEqual) {
                ClientAPIMixin.methods.getJobLocations(jobIds).then(response => {
                    // group same location, but retain jobs
                    var result = Object.groupBy(response, ({ Location }) => `${Location?.Longitude},${Location?.Latitude}`);
                    // remove unwanted locations
                    if (result["undefined,undefined"]) {
                        delete result["undefined,undefined"]
                    }
                    this.markers = Object.keys(result).map(key => {
                        const e = result[key]
                        return {
                            id: key,
                            jobs: e,
                            location: { lng: e[0]?.Location?.Longitude, lat: e[0]?.Location?.Latitude },
                            title: e.length > 1 ? 'Multiple jobs' : e[0].DisplayName,
                            pinElementOptions: {
                                glyphColor: '#FFFFFF',
                                scale: 1
                            }
                        }
                    })
                });
                this.jobIds = jobIds;
            }
            else {
                const hoverJob = this.getJobListSelection.find(j => j.hover == true)
                const selectedJob = this.getJobListSelection.find(j => j.selected == true)

                const hoverColor = window.getComputedStyle(document.body).getPropertyValue('--v-primary-lighten1');
                const hoverColorBackground = window.getComputedStyle(document.body).getPropertyValue('--v-primary-base');
                const hoverColorBorder = window.getComputedStyle(document.body).getPropertyValue('--v-primary-darken1');
                
                const selectedColor = window.getComputedStyle(document.body).getPropertyValue('--v-tertiary-lighten1');
                const selectedColorBackground = window.getComputedStyle(document.body).getPropertyValue('--v-tertiary-base');
                const selectedColorBorder = window.getComputedStyle(document.body).getPropertyValue('--v-tertiary-darken1');
                

                this.markers.forEach(e => {
                    if (hoverJob) {
                        e.hover = e.jobs.find(j => j.Id == hoverJob.Id) != undefined
                    }                    
                    else {
                        e.hover = false
                    }
                    if (selectedJob) {
                        e.selected = e.jobs.find(j => j.Id == selectedJob.Id) != undefined
                    }
                    else {
                        e.selected = false
                    }
                    e.pinElementOptions = {
                        glyphColor: e.selected ? selectedColor : e.hover ? hoverColor : undefined,
                        background: e.selected ? selectedColorBackground : e.hover ? hoverColorBackground : undefined,
                        borderColor: e.selected ? selectedColorBorder : e.hover ? hoverColorBorder : undefined,
                        scale: e.hover ? 1.5 : 1
                    }
                })
            }
        }
    },
  
    computed: {
        getJobListSelection() {
            return this.$store.getters["plannerstore/UnplannedJobList"];
        },
    },

    watch: {
        getJobListSelection: {
            handler: function () { this.getJobLocations() },
            deep: true
        },

        routeData() {
            this.getRouteData()
        }
    }
}
</script>
